import React, { useEffect, useState } from 'react';
import { useGetTeamQuery } from '../../features/team/teamApi';
import { useGetProjectsQuery } from '../../features/projects/projectsApi';
import { useNavigate, useParams } from 'react-router-dom';
import { useEditTaskMutation, useGetTaskQuery } from '../../features/task/taskApi';

const EditForm = () => {
  const {taskId} = useParams();
  const navigate = useNavigate();
  const [taskName, setTaskName] = useState("")
  const [assignedTo, setAssignedTo] = useState("");
  const [project, setProject] = useState("");
  const [date, setDate] = useState("");

  
  const {data:team, isLoading:teamLoading, isError:teamError} = useGetTeamQuery()
  const {data:projects, isLoading:projectsLoading, isError:projectsError} = useGetProjectsQuery();
  const {data:task, isLoading:taskLoading, isError:taskError} = useGetTaskQuery(taskId);
  const [editTask, { isSuccess }] = useEditTaskMutation();

  

  useEffect(() => {
    if(task?.id == taskId){
      const {taskName, project, teamMember, deadline } = task;
      setAssignedTo(JSON.stringify(teamMember));
      setProject(JSON.stringify(project));
      setDate(deadline);
      setTaskName(taskName);
    }
  },[task])

  useEffect(() => {
    if(isSuccess){
      navigate('/')
    }
  },[isSuccess])

 

 if(teamLoading || projectsLoading || taskLoading){
      return <div> Loading...</div>
  }

  

  const handleSubmit = (e) => {
      e.preventDefault();
      
      const data = {
          taskName,
          deadline: date,
          project: JSON.parse(project),
          teamMember: JSON.parse(assignedTo),
          status: "pending"
      }

      editTask({id:taskId, data})

  } 

 
 
    return (
      <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="fieldContainer">
        <label htmlFor="lws-taskName">Task Name</label>
        <input
          type="text"
          name="taskName"
          id="lws-taskName"
          required
          placeholder="Implement RTK Query"
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
        />
      </div>

      <div className="fieldContainer">
        <label>Assign To</label>
        <select name="teamMember" id="lws-teamMember" required value={assignedTo} onChange={(e) => setAssignedTo(e.target.value)}>
          {
              team.map((member) => {
                 const {id, name} = member || {};
                 return (
                  <option key={id} value={JSON.stringify(member)}>{name}</option>
                 )
              })
          }
        </select>
      </div>
      <div className="fieldContainer">
        <label htmlFor="lws-projectName">Project Name</label>
        <select id="lws-projectName" name="projectName" required value={project} onChange={(e) => setProject(e.target.value)}>
        {
              projects.map((project) => {
                 const { projectName, id} = project || {};
                 return (
                  <option key={id}  value={JSON.stringify(project)}>{projectName}</option>
                 )
              })
          }
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lws-deadline">Deadline</label>
        <input type="date" name="deadline" id="lws-deadline" required value={date} onChange={(e) => setDate(e.target.value)}/>
      </div>

      <div className="text-right">
        <button type="submit" className="lws-submit">Save</button>
      </div>
    </form>
    );
};

export default EditForm;